import { Div, Button, A, P, Br } from 'alkali'
import Dialog from '../generic/DialogAlkali'
import './DataImportTemplateDialog.scss'

const DRE_TECH_REQ_EMAIL = 'dretechrequest@drevidence.com'

export default class DataImportTemplateDialog extends Dialog('#data-import-template-dlg') {
	get defaults() {
		return {
			close: true,
		}
	}

	created(props) {
		props.head = {
			titleText: 'Collection Template'
		}
		props.foot = {}
		super.created(props)
	}

	ready() {
		this.body.append([
			P([
				'To upload your own extracted data to a collection, copy your data into this xsl template. Do not change any column headers or your data cannot be uploaded. Once complete, email this file to ',
				A({ href: 'mailto:' + DRE_TECH_REQ_EMAIL }, DRE_TECH_REQ_EMAIL),
				' with the name of your collection in the subject header.'
			]),
			Br,
			P('See the help content for more information on collections.')
		])
		this.footer.leftControls?.remove()
		this.footer.rightControls?.remove()
		this.footer.append([
			Button({ type: 'button' }, [
				A({ href: '/data-import-template.xlsx' }, 'Download Template')
			])
		])
	}
}